function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.164 21.212l16.695 84.504a7.329 7.329 0 01-5.767 8.607l-122.65 24.231a7.328 7.328 0 01-8.607-5.766L.14 48.283a7.328 7.328 0 015.767-8.606l122.65-24.231a7.329 7.329 0 018.607 5.766z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.092 114.324l-122.65 24.229c-3.967.786-7.822-1.798-8.608-5.765l-1.1-5.569a7.81 7.81 0 003.849.206L137.162 21.211l16.698 84.505a7.334 7.334 0 01-5.768 8.608z",
  fill: "url(#paint1_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.475 38.301v86.138a7.327 7.327 0 01-7.325 7.325H16.128a7.328 7.328 0 01-7.325-7.325V38.301a7.328 7.328 0 017.325-7.325H141.15a7.327 7.327 0 017.325 7.325z",
  fill: "url(#paint2_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.599 131.764h-95.47a7.326 7.326 0 01-7.326-7.325V38.301a7.326 7.326 0 017.325-7.325H141.15a7.325 7.325 0 017.325 7.325v58.505a4.27 4.27 0 01-1.227 2.996l-28.576 29.002a9.93 9.93 0 01-7.073 2.96z",
  fill: "url(#paint3_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.854 44.85v64.488l-14.547 14.763h-97.67a6.214 6.214 0 01-6.211-6.212V44.851a6.214 6.214 0 016.212-6.212h106.004a6.214 6.214 0 016.212 6.212z",
  fill: "url(#paint4_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.475 118.578v5.861a7.327 7.327 0 01-7.325 7.325H16.128a7.328 7.328 0 01-7.325-7.325v-5.861h139.672z",
  fill: "url(#paint5_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.462 118.551a6.182 6.182 0 00.234 1.149l.029.089c.055.171.116.34.185.505l.02.044a6.358 6.358 0 00.523.968l.064.095c.093.136.192.268.295.395l.079.095c.106.126.217.249.333.366l.074.072c.11.107.222.21.34.309.022.019.043.039.066.057a6.183 6.183 0 003.933 1.406h97.669c3.047-3.094 7.246-7.354 11.266-11.434l-33.001-30.275a6.67 6.67 0 00-9.017 0L77.91 95.825l-23.022-23.01c-2.728-3.266-7.832-3.18-10.433.262l-25.03 33.121v11.691c0 .197.012.391.03.583l.007.079z",
  fill: "url(#paint6_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.575 112.668c-4.016 4.072-8.206 8.325-11.251 11.415l-29.702-.024-46.444-.039 27.41-25.148 17.965-16.48a6.67 6.67 0 019.018 0l33.004 30.276z",
  fill: "url(#paint7_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.57 82.392a6.67 6.67 0 00-9.018 0l-17.964 16.48 19.034 25.186 29.701.025c3.045-3.09 7.235-7.343 11.251-11.415L101.57 82.392z",
  fill: "url(#paint8_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.531 87.862c-1.131.919-2.912.706-3.747-.642l-.003-.004c-.988-1.603-3.317-1.603-4.306 0v.004c-.988 1.603-3.32 1.603-4.308 0v-.004a2.502 2.502 0 00-2.155-1.201c-.83 0-1.662.398-2.154 1.201-.898 1.456-2.902 1.589-3.999.402l5.695-5.224a6.66 6.66 0 019.016 0l5.961 5.468z",
  fill: "url(#paint9_linear)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.531 87.862c-1.131.919-2.912.706-3.747-.642l-.003-.004c-.988-1.603-3.317-1.603-4.306 0v.004c-.988 1.603-3.32 1.603-4.308 0v-.004a2.502 2.502 0 00-2.155-1.201c-.83 0-1.662.398-2.154 1.201-.898 1.456-2.902 1.589-3.999.402l5.695-5.224a6.66 6.66 0 019.016 0l5.961 5.468z",
  fill: "url(#paint10_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.057 81.77c-.042 0-.083.003-.125.004a9.502 9.502 0 00-18.155-4.932 2.953 2.953 0 00-3.712 4.117 5.51 5.51 0 001.93 10.672h20.062a4.93 4.93 0 100-9.86z",
  fill: "#008BF2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.655 124.101l-69.016-.081a6.215 6.215 0 01-5.213-6.131v-11.691l25.029-33.12c2.669-3.532 7.974-3.532 10.643 0L74.59 98.871l19.033 25.187.032.042z",
  fill: "url(#paint11_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.22 79.86c-1.103 1.165-3.09 1.022-3.984-.423v-.007a2.51 2.51 0 00-2.155-1.198c-.83 0-1.658.398-2.154 1.201a2.514 2.514 0 01-2.155 1.202 2.513 2.513 0 01-2.154-1.202 2.514 2.514 0 00-2.154-1.201c-.832 0-1.66.401-2.155 1.201-.89 1.446-2.87 1.589-3.977.426l5.122-6.78c2.668-3.534 7.975-3.534 10.643 0l5.123 6.78z",
  fill: "url(#paint12_linear)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.1 98.555s-.216.613-1.069 1.466c-.316.316-28.191 28.613-28.191 28.613a10.504 10.504 0 01-7.481 3.131 4.396 4.396 0 004.396-4.396v-21.488a7.325 7.325 0 017.325-7.326h25.02z",
  fill: "url(#paint13_linear)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.432 62.156c-.042 0-.083.002-.125.004a9.502 9.502 0 00-18.155-4.932 2.953 2.953 0 00-3.712 4.117 5.51 5.51 0 001.93 10.672h20.062a4.93 4.93 0 100-9.86z",
  fill: "#008BF2"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.854 66.676l-15.207-15.207a14.877 14.877 0 00-10.808-4.639c-8.243 0-14.925 6.683-14.925 14.925 0 4.255 1.783 8.09 4.639 10.809l36.301 36.301v-42.19z",
  fill: "url(#paint14_linear)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.839 76.68c8.243 0 14.925-6.683 14.925-14.926s-6.682-14.925-14.925-14.925-14.925 6.682-14.925 14.925 6.682 14.925 14.925 14.925z",
  fill: "url(#paint15_linear)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M143.5 160c27.338 0 49.5-22.162 49.5-49.5S170.838 61 143.5 61 94 83.162 94 110.5s22.162 49.5 49.5 49.5z",
  fill: "#1DC05E"
}), React.createElement("path", {
  d: "M193 110.5c0 27.225-22.275 49.5-49.5 49.5-15.778 0-29.7-7.115-38.672-18.562 8.353 6.806 19.181 10.828 30.938 10.828 27.225 0 49.5-22.275 49.5-49.5 0-11.756-4.022-22.585-10.828-30.938C185.885 80.8 193 94.722 193 110.5z",
  fill: "#1DC05E"
}), React.createElement("path", {
  d: "M170.416 96.269l-32.175 35.269c-2.166 2.475-5.879 2.475-8.044 0l-13.613-15.16c-1.856-2.166-1.856-5.569.31-7.734 2.165-1.856 5.568-1.856 7.734.309l9.591 10.828 28.153-30.628c2.165-2.166 5.569-2.475 7.734-.31 2.166 1.857 2.166 5.57.31 7.426z",
  fill: "#fff"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 84.531,
  y1: 112.761,
  x2: 88.721,
  y2: 132.663,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#363F3E",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#303033"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 115.297,
  y1: 119.557,
  x2: 72.862,
  y2: 77.123,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#1ACEB8",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#04959C"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 123.656,
  y1: 126.39,
  x2: 140.147,
  y2: 142.885,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#97AAAA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 78.641,
  y1: 27.799,
  x2: 78.641,
  y2: 134.611,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 78.642,
  y1: 62.425,
  x2: 78.642,
  y2: 140.19,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3FA9F5"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0071E2"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 78.641,
  y1: 123.439,
  x2: 78.641,
  y2: 133.093,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C2CECE",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 0.179,
  stopColor: "#AFBCBC",
  stopOpacity: 0.179
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#5B6A6A"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 75.487,
  y1: 115.047,
  x2: 32.854,
  y2: 72.416,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#008BF2",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0046E2"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 90.879,
  y1: 72.088,
  x2: 90.879,
  y2: 126.754,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C2D600"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7BD101"
})), React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 76.97,
  y1: 78.553,
  x2: 80.291,
  y2: -84.974,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#97AAAA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 97.198,
  y1: 80,
  x2: 97.198,
  y2: 87.813,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 96.506,
  y1: 87.046,
  x2: 88.443,
  y2: 78.984,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C2CECE",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 0.179,
  stopColor: "#AFBCBC",
  stopOpacity: 0.179
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#5B6A6A"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 56.542,
  y1: 59.867,
  x2: 56.542,
  y2: 127.402,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C2D600"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7BD101"
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 49.778,
  y1: 70.571,
  x2: 49.778,
  y2: 78.839,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 116.59,
  y1: 102.012,
  x2: 131.027,
  y2: 116.452,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 142.779,
  y1: 92.686,
  x2: 91.665,
  y2: 41.576,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#008BF2",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0046E2"
})), React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 111.843,
  y1: 35.884,
  x2: 111.843,
  y2: 88.981,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFCF95"
}), React.createElement("stop", {
  offset: 0.427,
  stopColor: "#FFC954"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC200"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(94 61)",
  d: "M0 0h99v99H0z"
})));

var SvgSuccessIcon = function SvgSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 193,
    height: 160,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-icon.ee54200f.svg";
export { ForwardRef as ReactComponent };